import { getRequest, postRequest } from "../../actions/Handler";


const filterDataValues = (data: any) => {
  const filterEventId = JSON.parse(sessionStorage.getItem("eventReportId") || "{}")
  const filterSiteName = JSON.parse(sessionStorage.getItem("siteName") || "{}")
  const filterSub = JSON.parse(sessionStorage.getItem("subCategory") || "{}")
  const filterService = JSON.parse(sessionStorage.getItem("serviceLine") || "{}")
  const filterGender = JSON.parse(sessionStorage.getItem("gender") || "{}")
  const filterAge = JSON.parse(sessionStorage.getItem("age") || "{}")
  const filterAgeUnit = JSON.parse(sessionStorage.getItem("ageUnit") || "{}")
  const filterStatus = JSON.parse(sessionStorage.getItem("status") || "{}")
  const filterReviewStatus = JSON.parse(sessionStorage.getItem("reviewStatus") || "{}")
  const filterRegion = JSON.parse(sessionStorage.getItem("region") || "{}")
  const filterDOSFrom = JSON.parse(sessionStorage.getItem("dosFromDate") || "null")
  const filterDOSTo = JSON.parse(sessionStorage.getItem("dosToDate") || "null")
  const isAscending = JSON.parse(sessionStorage.getItem("isAscending") || "null")
  const sortedColumn = sessionStorage.getItem("sortedColumn")
  const pageLimit = JSON.parse(sessionStorage.getItem("pageLimit") || "null")
  const pageNo = JSON.parse(sessionStorage.getItem("pageNo") || "null")
  const filterRiskStatus = JSON.parse(sessionStorage.getItem("riskReviewStatus") || "{}")
  
  if (filterEventId !== null) {
    data.eventReportId = filterEventId
  }
  if (filterSiteName !== null) {
    data.siteName = filterSiteName
  }
  if (filterSub !== null) {
    data.subCategory = filterSub
  }
  if (filterService !== null) {
    data.serviceLine = filterService
  }
  if (filterGender !== null) {
    data.gender = filterGender
  }
  if (filterAge !== null) {
    data.age = filterAge
  }
  if (filterAgeUnit !== null) {
    data.ageUnit = filterAgeUnit
  }
  if (filterStatus !== null) {
    data.status = filterStatus
  }
  if (filterReviewStatus !== null) {
    data.reviewStatus = filterReviewStatus
  }
  if (filterRegion !== null) {
    data.region = filterRegion
  }
  if (filterDOSFrom !== "null") {
    data.dosFromDate = filterDOSFrom
  }
  if (filterDOSTo !== "null") {
    data.dosToDate = filterDOSTo
  }
  if(filterRiskStatus!=="null"){
    data.riskReviewStatus=filterRiskStatus
  }
  if(isAscending !== "null"){
    data.isAscendingOrder = isAscending
  }
  if(sortedColumn !== "null"){
    data.sortedColumn = sortedColumn
  }
  if(pageLimit !== "null"){
    data.limit = pageLimit
  }
  if(pageNo !== "null"){
    data.page = pageNo
  }

}

const SetDateToLocale=(dt:Date)=>{
  var newDate = new Date(dt.getTime() - dt.getTimezoneOffset()*60*1000);
  return newDate;
}
const allSites = async (data: any) => {
  data.dos = null;
  filterDataValues(data);
  return new Promise((resolve, reject) => {
    postRequest({ url: "api/EventReport/GetAll", data }).then((res: any) => {
      return resolve({
        data: res.eventReports,
        totalCount: res.totalRecordCount,
      });
    });
  });
};

const myEventReports = async (data: any) => {
  data.dos = null;
  filterDataValues(data);
  return new Promise((resolve, reject) => {
    postRequest({ url: "api/EventReport/GetMyEventReports", data }).then(
      (res: any) => {
        return resolve({
          data: res.eventReports,
          totalCount: res.totalRecordCount,
        });
      }
    );
  });
};

const riskEventReports = async (data: any) => {
  data.dos = null;
  filterDataValues(data);
  return new Promise((resolve, reject) => {
    postRequest({ url: "api/EventReport/GetRiskEventReports", data }).then(
      (res: any) => {
        return resolve({
          data: res.eventReports,
          totalCount: res.totalRecordCount,
        });
      }
    );
  });
};

const completeRecommendation = async (data: any) => {
  return new Promise((resolve, reject) => {
    getRequest({
      url: `api/EventReportReview/GetRecommendations?eventReportId=${data.eventReportId}&reviewType=${data.type}`,
    })
      .then((res: any) => {
        res.recommendationCreatedOn=SetDateToLocale(new Date(res.inspectionCompletedOn));
        return resolve({
          data: res,
          totalCount: res.length,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  });
};

export { allSites, completeRecommendation, myEventReports, riskEventReports };
